var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUseMyCurrentLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17562",
    "data-name": "Group 17562",
    transform: "translate(-919 -573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cursor",
    transform: "translate(923 577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16412",
    "data-name": "Group 16412",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8255",
    "data-name": "Path 8255",
    d: "M11.989.046a.437.437,0,0,0-.391,0h0L.242,5.724a.437.437,0,0,0,.117.82l4.507.82.82,4.507a.437.437,0,0,0,.367.354.426.426,0,0,0,.062,0,.437.437,0,0,0,.391-.242L12.184.632A.437.437,0,0,0,11.989.046Z",
    transform: "translate(-0.001 0)",
    fill: "#c22127"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1999",
    "data-name": "Rectangle 1999",
    width: 20,
    height: 20,
    transform: "translate(919 573)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseMyCurrentLocation);
export default __webpack_public_path__ + "static/media/use_my_current_location.af0d792649d66656bb4e3451f9e23559.svg";
export { ForwardRef as ReactComponent };